import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent, reactive, toRefs } from "vue"; // modules

import AuthModule from "@/store/modules/auth";
import ModalModule from "@/store/modules/modal"; // components

import { NavbarAvatar } from "@/components/index"; // interfaces

import { ModalStatus } from "@/constants/modal"; // helpers

import { redirectToLoginPage } from "@/utils/helpers/router.helper"; //services

import DatabaseService from "@/services/database.service";
import dayjs from "dayjs";
import CashFloatModule from "@/store/modules/cash-float";
import { openTopUpForm, confirmLogout, hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import AppModule from "@/store/modules/app";
import DeviceModule from "@/store/modules/device";
import { LogService } from "@/services/logging";
import POSConfigModule from "@/store/modules/pos-config";
import CommonModule from "@/store/modules/common";
import { closeCustomerDisplay, hasCustomerDisplay, openCustomerDisplay } from "@/utils/vue-helpers/customer-display";
import { processAdditionalEvents } from "@/utils/helpers/compliance";
import { EventType } from "@smeetz/compliance-common";
import NotificationService from "@/services/notification.service";
import i18n from "@/lang";
export default defineComponent({
  name: "NavbarMainMenu",
  components: {
    NavbarAvatar: NavbarAvatar
  },
  setup: function setup() {
    var state = reactive({
      onLogOut: function () {
        var _onLogOut = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!CashFloatModule.cashFloat) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return confirmLogout();

                case 3:
                  return _context.abrupt("return");

                case 4:
                  AuthModule.UserLogOut(); // remove gId parameter if it is set

                  if (AppModule.gid) {
                    AppModule.removeGID();
                  }

                  redirectToLoginPage();

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onLogOut() {
          return _onLogOut.apply(this, arguments);
        }

        return onLogOut;
      }(),
      toggleModalVisible: function toggleModalVisible(item) {
        ModalModule.setStatus(item);
      },
      dataBackupHandler: function () {
        var _dataBackupHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var db, data, a, file, filename;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return DatabaseService.db;

                case 2:
                  db = _context2.sent;
                  _context2.next = 5;
                  return db === null || db === void 0 ? void 0 : db.exportJSON();

                case 5:
                  data = _context2.sent;
                  //downloading the file
                  a = document.createElement("a");
                  file = new Blob([JSON.stringify(data)], {
                    type: "application/json"
                  });
                  filename = "smeetz-pos-".concat(dayjs().format("DD-MM-YYYY_HH-mm-ss"), ".json");
                  a.href = URL.createObjectURL(file);
                  a.download = filename;
                  a.click();

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function dataBackupHandler() {
          return _dataBackupHandler.apply(this, arguments);
        }

        return dataBackupHandler;
      }(),
      startSales: function () {
        var _startSales = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return openTopUpForm();

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function startSales() {
          return _startSales.apply(this, arguments);
        }

        return startSales;
      }()
    });
    var countryCode = computed(function () {
      return POSConfigModule.getGroupCountryCode;
    });
    var isCustomerDisplayOpened = computed(function () {
      return CommonModule.isCustomerDisplayOpened;
    }); // Lets write a computed property that returns true only in TEST environment

    var isTEST = computed(function () {
      var env = process.env.VUE_APP_ENV;

      if (env === "test" || env === "TEST") {
        return true;
      }

      return false;
    });
    var hasLocation = computed(function () {
      // If there is no hardware location (machine not linked to a location or user using a browser) we don't show device settings
      if (DeviceModule.hardwareLocation) {
        return true;
      } else {
        return false;
      }
    });

    function downloadCSV(csvString, filename) {
      // Create a Blob from the CSV string
      var blob = new Blob([csvString], {
        type: "text/csv;charset=utf-8;"
      }); // Create a temporary <a> element

      var link = document.createElement("a");

      if (link.download !== undefined) {
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename); // Append link, click it, and remove

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up

        URL.revokeObjectURL(url);
      }
    }

    function exportFiscalArchive() {
      return _exportFiscalArchive.apply(this, arguments);
    }

    function _exportFiscalArchive() {
      _exportFiscalArchive = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var result, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                AppModule.updatedIsLoading(true);
                _context4.prev = 1;
                LogService.info("Compliance: Exporting fiscal archive...");
                _context4.next = 5;
                return processAdditionalEvents(EventType.EXPORT_FISCAL_ARCHIVE);

              case 5:
                result = _context4.sent;
                LogService.info("Compliance: export fiscal archive result", {
                  result: result
                });
                data = result === null || result === void 0 ? void 0 : result.data;

                if (!(!data || !data.csvContent || !data.fileName)) {
                  _context4.next = 13;
                  break;
                }

                LogService.info("Compliance: No data received when exporting fiscal archive");
                NotificationService.showCustomError(i18n.global.t("compliance.fiscal-archive-error"));
                AppModule.updatedIsLoading(false);
                return _context4.abrupt("return");

              case 13:
                downloadCSV(data.csvContent, data.fileName);
                NotificationService.showCustomSuccess(i18n.global.t("compliance.fiscal-archive-exported"));
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](1);
                LogService.info("Compliance: Error exporting fiscal archive", {
                  error: _context4.t0
                });
                NotificationService.showCustomError(i18n.global.t("compliance.fiscal-archive-error"));

              case 21:
                _context4.prev = 21;
                AppModule.updatedIsLoading(false);
                return _context4.finish(21);

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 17, 21, 24]]);
      }));
      return _exportFiscalArchive.apply(this, arguments);
    }

    return _objectSpread(_objectSpread({
      ModalStatus: ModalStatus
    }, toRefs(state)), {}, {
      hasSalesStarted: hasSalesStarted,
      hasLocation: hasLocation,
      CashFloatModule: CashFloatModule,
      DeviceModule: DeviceModule,
      openCustomerDisplay: openCustomerDisplay,
      hasCustomerDisplay: hasCustomerDisplay,
      closeCustomerDisplay: closeCustomerDisplay,
      isCustomerDisplayOpened: isCustomerDisplayOpened,
      isTEST: isTEST,
      countryCode: countryCode,
      exportFiscalArchive: exportFiscalArchive
    });
  }
});